export default __webpack_public_path__ + "static/media/img_company_header7.5457cc7c.png";